import * as SectionTemplateActions from './action'
const initialState = {
    sectionTemplateSuccess: null,
    sectionTemplateError: null,
    sectionTemplateFile: null,
    sectionTemplateconfig: {},
    sectionTypeList: {},
    mappingSuccess: [],
    mappingFailure: [],
    mappingEdit: [],
    mappingEditFailure: [],
    masterDataValues: [],
    masterDataValuesFailure: []
}
const sectionTemplateFormReducer = (state = initialState, action) => {
    switch (action.type) {
        case SectionTemplateActions.SECTION_TEMPLATE_SUCCESS:
            return state = {
                ...state,
                sectionTemplateSuccess: action.data
            }
        case SectionTemplateActions.SECTION_TEMPLATE_ERROR:
            return state = {
                ...state,
                sectionTemplateError: action
            }
        case SectionTemplateActions.SECTION_TEMPLATE_FILE:
            return state = {
                ...state,
                sectionTemplateFile: action.data
            }
        case SectionTemplateActions.SECTION_TEMPLATE_CONFIGURATION_SUCCESS:
            return state = {
                ...state,
                sectionTemplateconfig: action.data
            }
        case SectionTemplateActions.SECTION_TEMPLATE_CONFIGURATION_ERROR:
            return state = {
                ...state,
                sectionTemplateconfig: action.error
            }
        case SectionTemplateActions.SECTION_TEMPLATE_TYPE_SUCCESS:
            return state = {
                ...state,
                sectionTypeList: action.data
            }
        case SectionTemplateActions.SECTION_TEMPLATE_TYPE_ERROR:
            return state = {
                ...state,
                sectionTypeList: action.error
            }
        case SectionTemplateActions.SECTION_TEMPLATE_MAPPING_SUCCESS:
            return state = {
                ...state,
                mappingSuccess: action.data
            }
        case SectionTemplateActions.SECTION_TEMPLATE_MAPPING_FAILURE:
            return state = {
                ...state,
                mappingFailure: action.data
            }
        case SectionTemplateActions.SECTION_TEMPLATE_MAPPING_EDIT_SUCCESS:
            return state = {
                ...state,
                mappingEdit: action.data
            }
        case SectionTemplateActions.SECTION_TEMPLATE_MAPPING_EDIT_FAILURE:
            return state = {
                ...state,
                mappingEditFailure: action.data
            }
        case SectionTemplateActions.GET_MASTER_DATA_KEY_VALUES_SUCCESS:
            return state = {
                ...state,
                masterDataValues: action.data
            }
        case SectionTemplateActions.GET_MASTER_DATA_KEY_VALUES_FAILURE:
            return state = {
                ...state,
                masterDataValuesFailure: action.data
            }

        case SectionTemplateActions.UPDATE_API_KEY_NAME_OF_SECTION_TEMPLATE_RESPONSE:
            return {
                ...state,
                apiKeyNameResponse: action.data
            }
        default:
            return state
    }
}
export default sectionTemplateFormReducer;